import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { confirmStripePayment } from './stripeUtils';

const StripePaymentForm = ({ clientSecret, onSuccess, onError, amount }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);

    try {
      const cardElement = elements.getElement(CardElement);
      
      const paymentIntent = await confirmStripePayment(
        stripe, 
        clientSecret, 
        {
          card: cardElement,
          billing_details: {
            name: 'John Doe',
            address: {
              line1: '123 Main Street',
              city: 'Mumbai',
              state: 'Maharashtra',
              postal_code: '400001',
              country: 'IN'
            },
          },
        }
      );

      onSuccess(paymentIntent);
    } catch (error) {
      onError(error.message);
    } finally {
      setIsProcessing(false);
    }
  };

  const cardElementOptions = {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
    },
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: '400px', margin: '0 auto' }}>
      <div style={{ 
        padding: '20px', 
        border: '1px solid #e0e0e0', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <CardElement options={cardElementOptions} />
      </div>
      
      <button
        type="submit"
        data-testid="stripe-pay-btn"
        disabled={!stripe || isProcessing}
        style={{
          width: '100%',
          padding: '12px',
          backgroundColor: '#007DC4',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          fontSize: '16px',
          cursor: isProcessing ? 'not-allowed' : 'pointer',
          opacity: isProcessing ? 0.6 : 1
        }}
      >
        {isProcessing ? 'Processing...' : `Pay $${amount}`}
      </button>
    </form>
  );
};

export default StripePaymentForm;